// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"364ae786","673":"75eedb30"}[chunkId] + ".chunk.js";
};